export const typographyRemSizes = {
  size: {
    display: '6rem',
    h1: '4.5rem',
    h2: '4rem',
    h3: '3rem',
    h4: '2.25rem',
    h5: '1.875rem',
    h6: '1.5rem',
    pL: '1.25rem',
    pM: '1.125rem',
    pS: '1rem',
    captionL: '0.875rem',
    captionM: '0.75rem',
    captionS: '0.625rem',
  },

  lineHeight: {
    display: '6.25rem',
    h1: '5rem',
    h2: '4.5rem',
    h3: '3.5rem',
    h4: '2.75rem',
    h5: '2.25rem',
    h6: '2rem',
    pL: '1.75rem',
    pM: '1.625rem',
    pS: '1.5rem',
    captionL: '1.25rem',
    captionM: '1rem',
    captionS: '0.875rem',
    captionXS: '0.75rem',
  },

  letterSpacing: {
    display: '-0.225rem',
    h1: '-0.138rem',
    h2: '-0.106rem',
    h3: '-0.063rem',
    h4: '-0.044rem',
    h5: '-0.031rem',
    h6: '-0.019rem',
    pL: '-0.013rem',
    pM: '-0.013rem',
    pS: '-0.013rem',
    captionL: '-0.006rem',
    captionM: '0rem',
    captionS: '0rem',
  },
}
